var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.921,
    height: 29.314,
    viewBox: "0 0 22.921 29.314",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63229",
    "data-name": "Group 63229",
    transform: "translate(-3.64)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30606",
    "data-name": "Rectangle 30606",
    width: 18.329,
    height: 27.494,
    transform: "translate(4.626 1.013)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30607",
    "data-name": "Rectangle 30607",
    width: 2.618,
    height: 12.219,
    transform: "translate(22.955 15.851)",
    fill: "#7d7d7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221829",
    "data-name": "Path 221829",
    d: "M25.9,16.282H23.35V2.2a.7.7,0,0,0-.7-.7H4.338a.7.7,0,0,0-.7.7V27.464a3.35,3.35,0,0,0,3.295,3.35H24.243A2.331,2.331,0,0,0,26.561,28.5V16.98A.7.7,0,0,0,25.9,16.282ZM6.934,29.418a1.954,1.954,0,0,1-1.94-1.954V2.9h16.96V28.5a2.275,2.275,0,0,0,.2.921Zm18.23-.921a.935.935,0,0,1-.935.921.921.921,0,0,1-.921-.921V17.678h1.857Z",
    transform: "translate(0 -1.5)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221830",
    "data-name": "Path 221830",
    d: "M6.758,29.1H9.424a.7.7,0,1,0,0-1.4H6.758a.7.7,0,1,0,0,1.4ZM18.3,27.7H12.258a.7.7,0,1,0,0,1.4H18.3a.7.7,0,1,0,0-1.4Zm0,2.638H15.636a.7.7,0,1,0,0,1.4H18.3a.7.7,0,1,0,0-1.4Zm-11.544,1.4h6.058a.7.7,0,1,0,0-1.4H6.758a.7.7,0,1,0,0,1.4Zm0,2.652H9.424a.7.7,0,1,0,0-1.4H6.758a.7.7,0,0,0,0,1.4ZM18.3,32.99H12.258a.7.7,0,0,0,0,1.4H18.3a.7.7,0,1,0,0-1.4Zm0,2.638H15.636a.7.7,0,1,0,0,1.4H18.3a.7.7,0,1,0,0-1.4Zm-11.544,1.4h6.058a.7.7,0,1,0,0-1.4H6.758a.7.7,0,1,0,0,1.4Zm2.666,1.242H6.758a.7.7,0,1,0,0,1.4H9.424a.7.7,0,1,0,0-1.4Zm8.878,0H12.258a.7.7,0,1,0,0,1.4H18.3a.7.7,0,1,0,0-1.4Z",
    transform: "translate(0.958 -14.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "\\u20B9",
    transform: "translate(10.64 10.157)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20B9")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.8db2ddca74ae0245ecb4813eb1593802.svg";
export { ForwardRef as ReactComponent };